import { render } from "./DialogRewardRules.vue?vue&type=template&id=4e228a04&scoped=true&ts=true"
import script from "./DialogRewardRules.vue?vue&type=script&lang=ts"
export * from "./DialogRewardRules.vue?vue&type=script&lang=ts"

import "./DialogRewardRules.vue?vue&type=style&index=0&id=4e228a04&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mahmoud\\Desktop\\Bugs\\Dubai Projects\\JC_2\\mongo-web\\website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e228a04"]])

export default __exports__